import { useQuery } from "@tanstack/react-query";
import itemGroupsService from "../../services/items/categories/itemGroups/itemGroups.service";

// 0016: the SINGLE fetch of the item-groups list (/ItemGroup/List). React Query dedups consumers +
// the StrictMode double-mount to ONE call. staleTime 60s. The connection dialog's mutations
// (connect/disconnect/reorder) carry no list data, so after each one it invalidates ["itemGroups"]
// and this mounted query refetches → the list updates immediately (and a re-open is fresh too).
// queryKey includes the params so a different page size is a distinct cache entry; invalidating the
// ["itemGroups"] prefix refreshes them all.
const useItemGroupsQuery = (queryParams) =>
  useQuery({
    queryKey: ["itemGroups", queryParams],
    queryFn: () => itemGroupsService.getItemGroups(queryParams).then((r) => r.data.payload),
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  });

export default useItemGroupsQuery;
